export default "__VITE_ASSET__BHiHYcUk__"